import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from './utils/api';
import "./styles/favoritelist.css"

export default function FavoriteList() {
    const [favoList, setFavoList] = useState([])
    useEffect(() => {
        api.getFavoriteList(localStorage.getItem("aws_JWT")).then((res) => {
            console.log(res);
            setFavoList(res.data)
        })
        .catch((err) => {
            if (err.response.status === 500) {
                return
            }
        })
    }, [])

    return (
        <>
        {
            favoList.length === 0 ? 
            <div className='favoList__none'>你還沒有按讚好物喔</div>
            : 
            <> 
            <div className="products">
            {favoList.map((product) => (
                <Link className="product-index" key={product.id} to={`/product?id=${product.id}`}>
                    <img src={product.main_image} className="product__image" alt="product" />
                    <div className="product__colors">
                        {product.colors.map((color) => (
                            <div
                                className="product__color"
                                style={{
                                    backgroundColor: `#${color.code}`,
                                }}
                                key={color.code}
                            />
                        ))}
                    </div>
                    <div className="product__title">{product.title}</div>
                    <div className="product-index__price">TWD.{product.price}</div>
                </Link>
            ))}
        </div>
        <div className="waypoint" style={{ height: '100px' }}></div>
        </>
        }
            
        </>
    );
}
